var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{attrs:{"value":"line"}},[_c('TabPane',{attrs:{"label":"进度曲线","name":"line"}},[_c('div',{attrs:{"id":"line"}})]),_c('TabPane',{attrs:{"label":"进度柱状图","name":"bar"}},[_c('progress-bar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }